import React from 'react';
import { money } from '../lib/constants';

export const ReceiptAllocation = ({ tx, currencySymbol }) => {
  if (tx.balanceAfter == null && !tx.loanRepayment) return null;
  const rows = [];
  if (tx.loanRepayment > 0) rows.push(['Applied to loans', 'loanRepayment'], ['Remaining deposit', 'savingsAmount']);
  if (tx.loanOutstandingAfter != null) rows.push(['Loan outstanding after', 'loanOutstandingAfter']);
  if (tx.balanceAfter != null) rows.push(['Account balance after', 'balanceAfter']);
  return <dl data-testid="receipt-allocation" className="border-y border-slate-200 py-5 mt-6 space-y-3 text-sm">
    {rows.map(([label, key]) => <div key={key} className="flex flex-wrap gap-2 justify-between"><dt className="text-slate-500">{label}</dt><dd data-testid={`receipt-${key}`} className={`font-mono font-semibold ${key === 'balanceAfter' && tx[key] < 0 ? 'text-rose-700' : 'text-slate-900'}`}>{currencySymbol} {money(tx[key])}</dd></div>)}
  </dl>;
};